import React, { useEffect, useRef, useState } from 'react';
import { Route, Switch, useHistory, useLocation, useRouteMatch } from 'react-router-dom/cjs/react-router-dom.min';
import { useDocumentTitle, useLocalStorage } from '~/hooks';
import ProjectTaskDetailsDrawer from '../../project-tasks/ProjectTaskDetailsDrawer';
import ProjectTaskEditDrawer from '../../project-tasks/ProjectTaskEditDrawer';
import TasksBoard from './TasksBoard';
import TasksList from './TasksList';
import GanttChart from './gantt/GanttChart';

export default function TasksTab({ project, onChange }) {
  const lastView = useLocalStorage({ key: `project_dashboard_tasks_tab_view` });
  const [view, setView] = useState(() => {
    const last = lastView.get();
    const allowed = ['list', 'board', 'gantt'];
    if (allowed.includes(last)) {
      return last;
    } else {
      lastView.set('list');
      return 'list';
    }
  });

  const handleViewChange = (view) => {
    setView(view);
    lastView.set(view);
  };

  const { path, url } = useRouteMatch();
  const history = useHistory();
  const location = useLocation();
  const documentTitle = useDocumentTitle();

  function handleRedirect() {
    history.push({ pathname: url, search: location.search });
    documentTitle.set(project.name);
  }

  const [refetch, setRefetch] = useState(() => () => {});

  // Reload the active view when the project is saved, since settings like dependencies change what tasks return.
  const prevProject = useRef(project);
  useEffect(() => {
    if (prevProject.current === project) return;
    prevProject.current = project;
    refetch();
  }, [project, refetch]);

  return (
    <>
      {(() => {
        switch (view) {
          case 'list':
            return (
              <TasksList
                project={project}
                onChange={onChange}
                onViewChange={handleViewChange}
                setRefetch={setRefetch}
              />
            );

          case 'board':
            return (
              <TasksBoard
                project={project}
                onChange={onChange}
                onViewChange={handleViewChange}
                setRefetch={setRefetch}
              />
            );

          case 'gantt':
            return <GanttChart project={project} onViewChange={handleViewChange} setRefetch={setRefetch} />;

          default:
            return null;
        }
      })()}

      <Switch>
        <Route path={`${path}/:taskId/details`}>
          <ProjectTaskDetailsDrawer project={project} onClose={handleRedirect} />
        </Route>

        <Route path={`${path}/:taskId/edit`}>
          <ProjectTaskEditDrawer project={project} onClose={handleRedirect} onSaved={refetch} />
        </Route>
      </Switch>
    </>
  );
}
